import { EnvironmentInstance } from './EnvironmentConst';

export enum FEATURE_TOGGLE {
  ADMIN_FUNDERS_GLOBAL_SETTING = 'adminFundersGlobalSettings',
  ADMIN_GRANTREE_PARTNERS_GLOBAL_SETTING = 'adminGranteePartnersGlobalSettings',
  ADMIN_GRANTREE_PARTNER_FINANCIAL = 'adminGranteePartnerFinancial',
  ADMIN_GRANTREE_PARTNER_CHAMPION = 'adminGranteePartnerChampion',
  CAUSE_FILTER = 'causeFilter',
  CHAMPION_FILTER = 'championFilter',
  FUNDER_CATALOG = 'fundersCatalog',
  FUNDER_CATEGORY = 'funderCategory',
  GLOBAL_SEARCH_ITEM = 'globalSearchItem',
  GRANTEE_PARTNERS_CATALOG = 'granteePartnersCatalog',
  GRANTEE_PARTNER_CATEGORY = 'granteePartnerCategory',
  GRANTEE_PARTNER_DETAILS_DOCUMENTS = 'granteePartnerDetailsDocuments',
  GRANTEE_PARTNER_DETAILS_FUNDERS = 'granteePartnerDetailsFunders',
  GRANTEE_PARTNER_DETAILS_OVERVIEW = 'granteePartnerDetailsOverview',
  GRANTEE_PARTNER_DETAILS_LEADER = 'granteePartnerDetailsLeader',
  GRANTEE_PARTNER_DETAILS_PROJECTS = 'granteePartnerDetailsProject',
  GRANTEE_PARTNER_DETAILS = 'granteePartnerDetailsFlag',
  GRANTEE_PARTNER_LOGO = 'granteePartnerLogo',
  GROUP_SETTINGS = 'groupsSettings',
  IMPORT_EXPORT_CSV = 'importExportCSV',
  MODERN_DESIGN = 'modernDesign',
  MY_FAVORITE_SETTINGS = 'myFavoritesSettings',
  SORT_BY_FUNCTION = 'sortByFunction',
  COMMUNITIES_ADMIN = 'communitiesAdmin',
  COMMUNITIES_CATALOG = 'communitiesCatalog',
}

export const EnvToggleMap = {
  [EnvironmentInstance.DEV]: 'Dev',
  [EnvironmentInstance.TEST]: 'Test',
  [EnvironmentInstance.STAGING]: 'Prod',
  [EnvironmentInstance.PROD]: 'Prod',
};
